<ng-template #cpuInput>
  <mat-checkbox [formControl]="formGroup.controls[formName]"
                [labelPosition]="labelPosition"
                [disableRipple]="true"
                (focusout)="onBlur()"
                (focusin)="onFocus()">
    {{formData.label}}
    <app-error [formName]="formName" [formGroup]="formGroup"></app-error>
  </mat-checkbox>
</ng-template>

<app-base [componentsTemplate]="cpuInput" [childContext]="ctx"></app-base>
